import { useEffect, useState } from 'react';

/**
 * A small hook that cycles through 1–3 dots while active.
 */
const useAnimatedDots = (isActive, intervalMs = 400) => {
    const [dotCount, setDotCount] = useState(1);

    useEffect(() => {
        if (!isActive) {
            setDotCount(1);
            return;
        }

        const interval = setInterval(() => {
            setDotCount((prev) => (prev === 3 ? 1 : prev + 1));
        }, intervalMs);

        return () => clearInterval(interval);
    }, [isActive, intervalMs]);

    return '.'.repeat(dotCount);
};

export default useAnimatedDots;
